// extracted by mini-css-extract-plugin
export default {"card":"t5-z"};